import $ from 'jquery';
import Swiper from 'swiper';

export default function($wrap) {
  $wrap.each((i, el) => {
    const $slider = $(el);
    const slidesPerView = +$slider.attr('data-show') || 1;
    const loop =
      typeof $slider.attr('data-loop') !== 'undefined'
        ? !!~~$slider.attr('data-loop')
        : true;
    const autoplay =
      typeof $slider.attr('data-autoplay') !== 'undefined'
        ? !!~~$slider.attr('data-autoplay')
        : { delay: 7000 };

    new Swiper(el, {
      // Optional parameters
      autoplay,
      loop,
      loopAdditionalSlides: 1,
      loopedSlides: 1,
      grabCursor: true,
      //simulateTouch: true,
      resistanceRatio: 0.3,
      slidesPerView,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },

      breakpoints: {
        // when window width is <= 768
        960: {
          slidesPerView: 1
        }
      },

      on: {
        init() {
          $slider
            .find('img.lazyload,img.lazyloading')
            .each((j, img) => window.lazySizes.loader.unveil(img));
        }
      }
    });
  });
}
